// extracted by mini-css-extract-plugin
export default {"wrapper":"tab-menu_wrapper__10-Tg","justifyStart":"tab-menu_justifyStart__Fefom","tabItem":"tab-menu_tabItem__cfECy","activeTabItem":"tab-menu_activeTabItem__7dc0m"};